__turbopack_context__.v({
  "badge": "PrizeBadgeOverlay-module__WoMRFW__badge",
  "prizeBadgeOverlay": "PrizeBadgeOverlay-module__WoMRFW__prizeBadgeOverlay",
  "text": "PrizeBadgeOverlay-module__WoMRFW__text",
});
